import React from 'react';
import Resource from '../../../../common/Resource'
import Panel from '../../../../common/layout/Panel'


export default class extends React.Component {
    render () {
        const data = {
            url: `/admin/products/mms/rates`,
            data: {
                data: [],
                metadata: []
            },
            userfilter:
                [
                    {
                        source: 'name',
                        label: 'Name',
                        type: 'text'
                    }
                ],
            metadata:
                [
                    {
                        'label': 'id',
                        'source': 'rate_id',
                        'type': 'primary',
                        'editable': false,
                        'visible': false
                    },
                    {
                        'label': 'Rate Table Name',
                        'source': 'name',
                        'type': 'text',
                        'editable': true,
                        'visible': true,
                        'placeholder': 'New Rate table...'
                    },
                    {
                        label: 'View',
                        value: '/products/mmsrates/{$id}',
                        type: 'link'
                    },
                    {
                        'label' : 'Actions',
                        'type': 'action_buttons'
                    }
                ]
        }
        return (
            <Panel title = "MMS Rate Tables">
                <Resource
                    addButtonText = "Add MMS Rate Table"
                    data = {data}
                    {...this.props}
                />
            </Panel>
        )
    }
}
